export const ServerURL = {    
    //PRODUCTION_HOST_URL: `http://localhost:44301/`,       
    //PRODUCTION_HOST_URL:  `http://13.200.71.164:9002/`,
    PRODUCTION_HOST_URL: `https://ecomapi.kassapos.co.in/`, 
    COMPANY_REF_ID: 69,
    COMPANY_NAME: `A2S Super Market`,
    COMPANY_ADDRESS: `Main road, Koovathur, Koovathur Post, Andimadam Taluk, Ariyalur District, Pincode: 621803`,
    COMPANY_URL: ``,
    COMPANY_EMAIL: ``,
    COMPANY_MOBILE: ``,
    COMPANY_PAYMENT_RAZ_KEY: `rzp_live_7dRl4dBQlFY2Ju`,    
    COMPANY_PAYMENT_RAZ_KEYNew: `rzp_live_7dRl4dBQlFY2Ju`,    
    CURRENCY: 'INR',
    MINIMUM_ORDER_AMOUNT: 300,
    CSAH_ON_DELIVERY_LIMIT: 300,
    MAP_KEY: 'AIzaSyC966V9u3Yu_TyIbqAiB4ukRNPBS5AWjhc'
   
};

export default ServerURL;
